/**
 * Define a contract for the given injection. When this injection is missing
 * at runtime this contract will throw an error to ensure the injection is
 * available.
 *
 * @param {Object} injection The contracted injection
 */
Function.prototype.contractInjection = function injectContract(context, injection) {
  if (typeof context[injection] === 'undefined') {
    throw new Error(`"${injection}" injection is missing in "${context.constructor.name}"! Inject "${injection}" as depedency to the "${context.constructor.name}" constructor and its super() call.`);
  }
};
